import { MultiSelect, MultiSelectProps } from 'primereact/multiselect';
import { ModuleLabel } from './module-label';

export interface ModuleOption { label: string; value: string; managed?: boolean }

/** Use the same type indicator in both options and removable selected chips. */
export function ModuleMultiSelect({ options, selectedOptions = options, value = [], onChange, ...props }: Omit<MultiSelectProps,
    'options' | 'value' | 'onChange' | 'itemTemplate' | 'selectedItemTemplate'> & {
    options: ModuleOption[]; selectedOptions?: ModuleOption[]; value?: string[]; onChange: (keys: string[]) => void;
}) {
    return <MultiSelect {...props} value={value} options={options} onChange={event => onChange(event.value)} display="chip"
        itemTemplate={(option: ModuleOption) => <ModuleLabel name={option.label} managed={option.managed} />}
        selectedItemTemplate={(key?: string) => {
            if (key === undefined) return props.placeholder;
            const option = selectedOptions.find(item => item.value === key);
            return <span className="p-multiselect-token">
                <ModuleLabel name={option?.label ?? key} managed={option?.managed} />
                {!props.disabled && <button type="button" className="p-multiselect-token-icon p-link pi pi-times-circle"
                    aria-label={`Remove ${option?.label ?? key}`} onClick={event => {
                        event.stopPropagation(); onChange(value.filter(item => item !== key));
                    }} onKeyDown={event => event.stopPropagation()} />}
            </span>;
        }} />;
}
